/* eslint prefer-spread: "off" */
/* eslint no-param-reassign: "off" */
/* eslint consistent-return: "off" */

/**
 * Cloned from: https://github.com/acronis/merkle-patricia-tree.git
 *
 * Dependencies:
 * npm i --save keccak@3.0.1
 * npm i --save rlp@2.0.0
 */

const rlp = require('rlp');
const createKeccakHash = require('keccak');

function TrieNode(type, key, value) {
  if (Array.isArray(type)) {
    // parse raw node
    this.parseNode(type);
  } else {
    this.type = type;
    if (type === 'branch') {
      const values = key;
      this.raw = Array(...Array(17));
      if (values) {
        values.forEach(function (keyVal) {
          this.set.apply(this, keyVal);
        });
      }
    } else {
      this.raw = Array(2);
      this.setValue(value);
      this.setKey(key);
    }
  }
}

Object.defineProperty(TrieNode.prototype, 'value', {
  get: function () {
    return this.getValue();
  },
  set: function (v) {
    this.setValue(v);
  }
});

Object.defineProperty(TrieNode.prototype, 'key', {
  get: function () {
    return this.getKey();
  },
  set: function (k) {
    this.setKey(k);
  }
});

/*
 * Converts a string OR a buffer to a nibble array
 * @method stringToNibbles
 * @param {Buffer| String} key
 */
function stringToNibbles(key) {
  const bkey = Buffer.from(key);
  const nibbles = [];

  for (let i = 0; i < bkey.length; i++) {
    let q = i * 2;
    nibbles[q] = bkey[i] >> 4;
    ++q;
    nibbles[q] = bkey[i] % 16;
  }
  return nibbles;
}

/*
 * Detrimines if a key has Arnold Schwarzenegger in it.
 * @method isTerminator
 * @param {Array} key - an hexprefixed array of nibbles
 */
function isTerminator(key) {
  return key[0] > 1;
}

/*
 * Determines the node type
 * Returns the following
 * - leaf - if teh node is a leaf
 * - branch - if the node is a branch
 * - extention - if the node is an extention
 * - unknown - if somehting fucked up
 */
function getNodeType(node) {
  if (node.length === 17) {
    return 'branch';
  } else if (node.length === 2) {
    const key = stringToNibbles(node[0]);
    if (isTerminator(key)) {
      return 'leaf';
    }

    return 'extention';
  }
}

// parses a raw node
TrieNode.prototype.parseNode = function (rawNode) {
  this.raw = rawNode;
  this.type = getNodeType(rawNode);
};

// sets the value of the node
TrieNode.prototype.setValue = function (key, value) {
  if (this.type !== 'branch') {
    this.raw[1] = key;
  } else {
    if (arguments.length === 1) {
      value = key;
      key = 16;
    }
    this.raw[key] = value;
  }
};

TrieNode.prototype.getValue = function (key) {
  if (this.type === 'branch') {
    if (arguments.length === 0) {
      key = 16;
    }

    const val = this.raw[key];
    if (val !== null && val !== undefined && val.length !== 0) {
      return val;
    }
  } else {
    return this.raw[1];
  }
};

/**
 * @param {Array} dataArr
 * @returns {Buffer} - returns buffer of encoded data
 * hexPrefix
 * */
function addHexPrefix(key, terminator) {
  // odd
  if (key.length % 2) {
    key.unshift(1);
  } else {
    // even
    key.unshift(0);
    key.unshift(0);
  }

  if (terminator) {
    key[0] += 2;
  }

  return key;
}

/*
 * Converts a  nibble array into a buffer
 * @method nibblesToBuffer
 * @param arr
 */
function nibblesToBuffer(arr) {
  const buf = Buffer.from(arr.length / 2);
  for (let i = 0; i < buf.length; i++) {
    let q = i * 2;
    buf[i] = (arr[q] << 4) + arr[++q];
  }
  return buf;
}

TrieNode.prototype.setKey = function (key) {
  if (this.type !== 'branch') {
    if (Buffer.isBuffer(key)) {
      key = stringToNibbles(key);
    } else {
      key = key.slice(0); // copy the key
    }

    key = addHexPrefix(key, this.type === 'leaf');
    this.raw[0] = nibblesToBuffer(key);
  }
};

function removeHexPrefix(val) {
  if (val[0] % 2) {
    val = val.slice(1);
  } else {
    val = val.slice(2);
  }

  return val;
}

// returns the key as a nibble
TrieNode.prototype.getKey = function () {
  if (this.type !== 'branch') {
    let key = this.raw[0];
    key = removeHexPrefix(stringToNibbles(key));
    return (key);
  }
};

TrieNode.prototype.serialize = function () {
  return rlp.encode(this.raw);
};

function isHexPrefixed(str) {
  return str.slice(0, 2) === '0x';
}

function padToEven(a) {
  if (a.length % 2) a = `0${a}`;
  return a;
}

function stripHexPrefix(str) {
  if (typeof str !== 'string') {
    return str;
  }
  return isHexPrefixed(str) ? str.slice(2) : str;
}

function intToHex(i) {
  if (!(i % 1 === 0)) {
    console.log('number is not a integer');
  }
  if (!(i >= 0)) {
    console.log('number must be positive');
  }
  let hex = i.toString(16);
  if (hex.length % 2) {
    hex = `0${hex}`;
  }

  return `0x${hex}`;
}

function intToBuffer(i) {
  const hex = intToHex(i);
  return Buffer.from(hex.slice(2), 'hex');
}

function toBuffer(v) {
  if (!Buffer.isBuffer(v)) {
    if (Array.isArray(v)) {
      v = Buffer.from(v);
    } else if (typeof v === 'string') {
      if (isHexPrefixed(v)) {
        v = Buffer.from(padToEven(stripHexPrefix(v)), 'hex');
      } else {
        v = Buffer.from(v);
      }
    } else if (typeof v === 'number') {
      v = intToBuffer(v);
    } else if (v === null || v === undefined) {
      v = Buffer.from([]);
    } else if (v.toArray) {
      // converts a BN to a Buffer
      v = Buffer.from(v.toArray());
    } else {
      throw new Error('invalid type');
    }
  }
  return v;
}

function sha3(a) {
  a = toBuffer(a);

  const h = createKeccakHash('keccak256');
  if (a) {
    h.update(a);
  }

  return Buffer.from(h.digest('hex'), 'hex');
}

TrieNode.prototype.hash = function () {
  return sha3(this.serialize());
};

TrieNode.prototype.toString = function () {
  let out = this.type;
  out += ': [';
  this.raw.forEach(function (el) {
    if (Buffer.isBuffer(el)) {
      out += `${el.toString('hex')}, `;
    } else if (el) {
      out += 'object, ';
    } else {
      out += 'empty, ';
    }
  });
  out = out.slice(0, -2);
  out += ']';
  return out;
};

TrieNode.prototype.getChildren = function () {
  const children = [];
  switch (this.type) {
    case 'leaf':
      // no children
      break;
    case 'extention':
      // one child
      children.push([this.key, this.getValue()]);
      break;
    case 'branch':
      for (let index = 0, end = 16; index < end; index++) {
        const value = this.getValue(index);
        if (value) {
          children.push([
            [index], value
          ]);
        }
      }
      break;
    default:
      break;
  }
  return children;
};

function isRawNode(node) {
  return Array.isArray(node) && !Buffer.isBuffer(node);
}

TrieNode.isRawNode = isRawNode;
TrieNode.addHexPrefix = addHexPrefix;
TrieNode.removeHexPrefix = removeHexPrefix;
TrieNode.isTerminator = isTerminator;
TrieNode.stringToNibbles = stringToNibbles;
TrieNode.nibblesToBuffer = nibblesToBuffer;
TrieNode.getNodeType = getNodeType;

module.exports = TrieNode;
